import { useState, useEffect } from 'react'
import { Unit, units as staticUnits } from '../data/units'
import { fetchUnitsFromSheet } from '../data/fetchUnits'

// Cache fetched units in memory so we don't re-fetch on every component mount
let cachedUnits: Unit[] | null = null
let lastFetchTime = 0
const CACHE_DURATION_MS = 60 * 60 * 1000 // 1 hour

export function useUnits() {
  const [units, setUnits] = useState<Unit[]>(cachedUnits || staticUnits)
  const [isLoading, setIsLoading] = useState(!cachedUnits)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const now = Date.now()

    // Use cache if fresh enough
    if (cachedUnits && now - lastFetchTime < CACHE_DURATION_MS) {
      setUnits(cachedUnits)
      setIsLoading(false)
      return
    }

    let cancelled = false

    async function loadUnits() {
      try {
        setIsLoading(true)
        const fetched = await fetchUnitsFromSheet()
        if (!cancelled && fetched.length > 0) {
          cachedUnits = fetched
          lastFetchTime = Date.now()
          setUnits(fetched)
          setError(null)
        }
      } catch (err) {
        if (!cancelled) {
          console.warn(
            'Failed to fetch units from Google Sheet, using static data:',
            err,
          )
          setError('Načítání dat z tabulky selhalo, zobrazuji uložená data.')
          setUnits(staticUnits)
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    loadUnits()

    return () => {
      cancelled = true
    }
  }, [])

  return { units, isLoading, error }
}
